/**
 *
 * ParkingType14326 constants
 *
 */

export const UNLOADING_LOADING_PARKING_TYPE = '4022244941000';
export const GUEST_PARKING_TYPE = '4022244917000';
